// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
require('../scss/utils/bootstrap/bootstrap.min.css');

require('animate.css/animate.min.css');
require('../scss/aboutUs.scss');
var mock = require('mockjs')
var $ = require('jquery');
window.jQuery = $
require('bootstrap-sass/assets/javascripts/bootstrap.min.js');
var common = require('./common');
var commonApi = require('../commonApi'); 

var minioUrl = commonApi.api.minioUrl;

var lang = '';
//var icon = require('../img/favicon.jpg');
//console.log(icon);
//alert('hello world');
//修改的位置，请求member数据的位置将data写成了死的数据，以及将渲染的前端的页面的12栅格化的位置的3改成了4
$(document).ready(function() {
    lang = common.initChangePage();

    getMember();
    if(lang == 'en') {
        $('#CO').css('bottom', '-160');
        $('.summary-box').addClass('summary-top');
        $('#CO').addClass('p-fit');
    }
    $('#aboutUs').addClass('active');

    var $root = $('html, body');
    $('.navta').click(function() {

        var href = $.attr(this, 'href');
        var navt = $(this).parent('.navt');
        var prevActive = navt.parents('.nav-two').find('.active');

        prevActive.removeClass('active');

		//now selected nav
        navt.addClass('active');
        $root.animate({
            scrollTop: $(href).offset().top
        }, 1000, function() {
            window.location.hash = href;
        });
        return false;
    });
    var CLWidth = $('.course-line-wrapper').width();
    var leftBoxWidth = CLWidth / 2;
    $('.course-line .left-box').width(leftBoxWidth);
	// $root.animate({
	// 	scrollTop: $('#summary-box').offset().top
	// }, 1000, function() {
	// 	window.location.hash = '#summary-box';
	// });

});

var dataArray = [];

function getMember() {
    var api = common.getAPI();
	//  var ajaxUrl = api + 'v1/member';
    var ajaxUrl = api + 'v1/member';
	//	console.log(ajaxUrl)
    $.ajax({
        url: ajaxUrl,
        type: 'get',
        dataType: 'json',
		//      dataType: 'text',
        data: {
            lang: lang === 'en' ? 'en' : 'zh'
        },
        success: function(data) {
			//      	

			//			if((typeof data)=='string'){
			//				data = eval('(' + data + ')');
			//			}
			//			console.log(mock.mock(data))

			//			data = mock.mock(data)
			//			
			//			if((typeof data)=='string'){
			//				console.log("string")
			//				data = eval('(' + data + ')');
			//				data.result = JSON.parse(data.result)
			//			}
			//			console.log(data)
			//下面的位置使用的是写死的数据方面切换现在的高层的人数，来查看不同的人数下的显示的样式
			
            if(data.status) {
				// data.result.push(datas.result[0])
                var str = '';
                var result = data.result;
                var len = result.length;
                var isZero = len % 3;
                var classLen = '';
				//下面的位置判断当前的显示的高层的人数，不同的人数显示不同的样式
                classLen = 'class="col-md-4 col-manager col-manager-img"';
                $('#col-manager').addClass('manager-pad')
                if(isZero == 0 || len == 5) {
                    classLen = 'class="col-md-4 col-manager col-manager-img"';
                    $('#col-manager').addClass('manager-pad')
                } else {
                    classLen = 'class="col-md-3 col-manager"';
                }
				// console.log(result);
                dataArray = result;
                var classAndStyle = (isZero === 0 || len === 5)? ' class="w-p100">' : ' class="w-p100" style="width:258.5px;height:321px">';
                for(var i = 0; i < result.length; i++) {
                    str += ' <div ' + classLen + '>' +
						'<div class="manager showModal" index=' + i + '   targetClass="managerModal1">' +
						'<img src=' + `${minioUrl + result[i].logo}` + classAndStyle +
						'<div class="bg d-n"></div>' +
						'<div class="bottom d-n">' +
						' <p class="nameManager">' + result[i].name + '</p>';
                    var title = result[i].title.split(';');
                    for(var j = 0; j < title.length; j++) {
                        str += '<p>' + title[j] + '</p>';

                    }
                    str += '</div></div> </div>';

                }
                $('#col-manager').html(str);

                $('.showModal').click(function() {
                    var targetClass = $(this).attr('targetClass');
                    var targetClassObj = $('.' + targetClass + '');
                    targetClassObj.modal('show');
                    var index = $(this).attr('index');
                    var windowOuterHeight = window.outerHeight;
					// 弹框遮盖问题
                    var mIndex = index === '0' || index === '1' || index === '3'  || index === '5' || index === '6' || index === '7'
                    if(windowOuterHeight < 820 && mIndex && lang === 'en') {
                        targetClassObj.find('.modal-dialog').attr('style', 'transform:translate(-50%, -30%) !important')
                    } else {
                        targetClassObj.find('.modal-dialog').attr('style', 'transform:translate(-50%, -50%) !important')
                    }
                    var title = dataArray[index].title.split(';');
                    var str = '';
                    for(var j = 0; j < title.length; j++) {
                        str += '<p>' + title[j] + '</p>';
                    }

                    var introduce = dataArray[index].introduce;
                    var introduceParagraphs = introduce.split('\n').filter(Boolean);
                    targetClassObj.find('.img').attr('src', `${minioUrl + dataArray[index].logo}`);
                    targetClassObj.find('.modal-name').html(dataArray[index].name);
                    targetClassObj.find('.modal-post').html(str);
                    targetClassObj.find('.modal-post-p').html(introduceParagraphs.map(item => `<div>${item}</div>`));
                });

                $('.manager').hover(function() {
                    $(this).find('.bottom').show();
                    $(this).find('.bg').show();
                }, function() {
                    $(this).find('.bottom').hide();
                    $(this).find('.bg').hide();

                });

            }
        },
        error: function(msg) {
            console.log(msg);
        }

    })
}


// WEBPACK FOOTER //
// ./src/aboutUs.js